import React from 'react';
import Navbar from "./Navbar";
import { FaLeaf, FaChartLine, FaCoins, FaChalkboardTeacher, FaCogs, FaHandshake } from "react-icons/fa";
import AboutCharts from './hooks/AboutCharts';
import Footer from './hooks/Footer';


const About = () => {
    const items = [
        {
            icon: '📄', // Replace with your SVG or icon
            title: 'Terms of Service',
            description: 'Read the Terms of Service and License Agreement for Blockit as well as our BlockitApp & Developer Agreements.',
            links: [
                { name: 'License Agreement', href: '#' },
                { name: 'Term of Services for Blockit Trade', href: '#' },
            ],
            iconBg: 'bg-green-500',
        },
        {
            icon: '🌐', // Replace with your SVG or icon
            title: 'Policies',
            description: 'Find out more about what information we collect at Blockit, how we use it, and what control you have over your data.',
            links: [{ name: 'Privacy Statement', href: '#' }],
            iconBg: 'bg-green-500',
        },
        {
            icon: '🛡️', // Replace with your SVG or icon
            title: 'Security',
            description: 'Learn more about how we keep your work and personal data safe when you’re using our services.',
            links: [
                { name: 'Blockit Trade Security', href: '#' },
                { name: 'Responsible Disclosure Policy', href: '#' },
            ],
            iconBg: 'bg-blue-500',
        },
    ];
    return (
        <>
            <div className='bg__color__about h-fit'>
                <Navbar />
                <div className='xl:pt-[10%] pt-[25%] mx-[10%]'>
                    <hr />
                </div>
                <div className='mx-auto md:max-w-7xl overflow-hidden md:py-[10%] xl:py-[10%] py-[45%]'>
                    <p className='text-white xl:text-[45px] text-[30px] font-bold pl-5 lg:text-[45px] md:text-[40px]'>About Portpay Investment </p>
                </div>
            </div>
            <div className='bg-black h-fit pb-[10%]'>
                <div className='mx-auto md:max-w-7xl overflow-hidden'>
                    <p className='text-gray-300 font-semibold pt-5 mx-5'>
                        Since 2016, we have been proudly empowering our clients to take control of their financial lives with confidence and clarity. As a trusted partner in their journey toward financial success, we are driven by a team of passionate, independent thinkers who are constantly exploring innovative ways to improve the trading experience for self-directed investors. Our unwavering commitment to putting our clients first has been the cornerstone of our approach, ensuring that we provide the tools, resources, and expertise needed to navigate the ever-changing financial landscape with ease.
                    </p>

                    <div className='pt-10 mx-5'>
                        <p className='font-bold text-[25px] text-white'>Trading instruments</p>

                        <div>
                            <p className='text-gray-300 font-semibold pt-5'>The foreign exchange market, widely recognized as the largest financial market in the world, offers a diverse array of financial instruments to trade daily, with an impressive average daily trading volume of $5 trillion. This dynamic market provides ample opportunities for traders, especially during periods of high volatility, which is considered the optimal time to engage in forex trading. At its core, forex trading involves exchanging currencies to capitalize on price fluctuations in currency pairs. Among the most traded pairs, often referred to as majors, are USD/JPY, GBP/USD, USD/CHF, and EUR/USD, which represent the currencies of some of the world's largest and most influential economies. This vibrant market continues to attract traders worldwide, offering both challenges and opportunities for those seeking to navigate its ever-evolving landscape.</p>
                        </div>
                    </div>
                </div>


                <div className='flex justify-center pt-[10%]'>
                    <p className='text-white text-[35px] text-center font-bold'>A <span className='text-[#20C55E]'>Relationship</span> on your terms.</p>
                </div>
                <div className='flex justify-center pt-2'>
                    <p className='text-gray-300 text-[20px] text-center '>Work with us the way you want.</p>
                </div>

                <div className="mx-auto md:max-w-7xl overflow-hidden mt-10">
                    <div className="grid mx-3 grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-3 sm:grid-cols-1 md:grid-cols-1">
                        {/* Investing */}
                        <div className="bg-green-500 p-6 rounded-lg flex flex-col justify-between space-y-4">
                            <div>
                                <FaLeaf className="text-white text-3xl mb-4" />
                                <h3 className="text-white font-bold text-lg">Investing</h3>
                                <div className="h-1 w-16 bg-white rounded my-4"></div> {/* Longer Line */}
                                <p className="text-white text-sm">
                                    A wide selection of investment products to help build a diversified portfolio.
                                </p>
                            </div>
                            <svg
                                className="w-6 h-6 text-white self-end mt-auto"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                            </svg>
                        </div>

                        {/* Trading */}
                        <div className="bg-blue-500 p-6 rounded-lg flex flex-col justify-between space-y-4">
                            <div>
                                <FaChartLine className="text-white text-3xl mb-4" />
                                <h3 className="text-white font-bold text-lg">Trading</h3>
                                <div className="h-1 w-16 bg-white rounded my-4"></div> {/* Longer Line */}
                                <p className="text-white text-sm">
                                    Powerful trading tools, resources, insight, and support.
                                </p>
                            </div>
                            <svg
                                className="w-6 h-6 text-white self-end mt-auto"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                            </svg>
                        </div>

                        {/* Wealth Management */}
                        <div className="bg-purple-500 p-6 rounded-lg flex flex-col justify-between space-y-4">
                            <div>
                                <FaCoins className="text-white text-3xl mb-4" />
                                <h3 className="text-white font-bold text-lg">Wealth Management</h3>
                                <div className="h-1 w-16 bg-white rounded my-4"></div> {/* Longer Line */}
                                <p className="text-white text-sm">
                                    Dedicated financial consultants to help reach your own specific goals.
                                </p>
                            </div>
                            <svg
                                className="w-6 h-6 text-white self-end mt-auto"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                            </svg>
                        </div>

                        {/* Investment Advisory */}
                        <div className="bg-gray-700 p-6 rounded-lg flex flex-col justify-between space-y-4">
                            <div>
                                <FaChalkboardTeacher className="text-white text-3xl mb-4" />
                                <h3 className="text-white font-bold text-lg">Investment Advisory</h3>
                                <div className="h-1 w-16 bg-white rounded my-4"></div> {/* Longer Line */}
                                <p className="text-white text-sm">
                                    A wide selection of investing strategies from seasoned portfolio managers.
                                </p>
                            </div>
                            <svg
                                className="w-6 h-6 text-white self-end mt-auto"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                            </svg>
                        </div>

                        {/* Smart Portfolio */}
                        <div className="bg-gray-400 p-6 rounded-lg flex flex-col justify-between space-y-4">
                            <div>
                                <FaCogs className="text-white text-3xl mb-4" />
                                <h3 className="text-white font-bold text-lg">Smart Portfolio</h3>
                                <div className="h-1 w-16 bg-white rounded my-4"></div> {/* Longer Line */}
                                <p className="text-white text-sm">
                                    A revolutionary, fully automated investment advisory service.
                                </p>
                            </div>
                            <svg
                                className="w-6 h-6 text-white self-end mt-auto"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                            </svg>
                        </div>

                        {/* Mutual Fund Advisor */}
                        <div className="bg-cyan-500 p-6 rounded-lg flex flex-col justify-between space-y-4">
                            <div>
                                <FaHandshake className="text-white text-3xl mb-4" />
                                <h3 className="text-white font-bold text-lg">Mutual Fund Advisor</h3>
                                <div className="h-1 w-16 bg-white rounded my-4"></div> {/* Longer Line */}
                                <p className="text-white text-sm">
                                    Specialized guidance from independent local advisors for high-net-worth investors.
                                </p>
                            </div>
                            <svg
                                className="w-6 h-6 text-white self-end mt-auto"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                            </svg>
                        </div>
                    </div>
                </div>

            </div>

            <div className='bg-[#2a2929] h-fit pb-[5%]'>
                <div className="mx-auto max-w-7xl overflow-hidden pt-10">
                    <div className="grid mx-3 grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-2 sm:grid-cols-1 md:grid-cols-1">
                        {/* Left Placeholder */}
                        <div className="b h-fit">
                            <div>
                                <AboutCharts />
                            </div>
                        </div>

                        {/* Right Card */}
                        <div className="bg-gray-900 text-white p-6 rounded-lg flex space-x-4">
                            {/* Icon Section */}
                            <div className="flex items-start justify-center">
                                <div className="bg-green-600 h-12 w-12 xl:flex  hidden items-center justify-center rounded-full ">
                                    <svg
                                        className="w-6 h-6 text-white"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 0v6m0-6h6m-6 0H6"
                                        />
                                    </svg>
                                </div>
                            </div>

                            {/* Content Section */}
                            <div className="flex-1">
                                {/* Title */}
                                <h3 className="text-xl font-bold mb-2">Why trade with  Portpay Investment ?</h3>
                                {/* Description */}
                                <p className="text-sm text-gray-400 mb-4">
                                    The best-rated ASIC broker in the industry. Dedicated account manager & personalized service. Regulated by
                                    the Australian Securities and Investment Commission. We are suggesting this broker so you can try their
                                    services on a demo account. Speak to your financial advisor before opening a live account.
                                </p>

                                {/* Bullet Points */}
                                <div className="grid grid-cols-2 gap-2 text-sm">
                                    <div className="flex items-center space-x-2">
                                        <svg
                                            className="w-4 h-4 text-blue-500"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M5 13l4 4L19 7"
                                            />
                                        </svg>
                                        <span>Direct Market Access (DMA)</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <svg
                                            className="w-4 h-4 text-blue-500"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M5 13l4 4L19 7"
                                            />
                                        </svg>
                                        <span>Free from UK Stamp Duty</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <svg
                                            className="w-4 h-4 text-blue-500"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M5 13l4 4L19 7"
                                            />
                                        </svg>
                                        <span>Leverage up to 1:500</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <svg
                                            className="w-4 h-4 text-blue-500"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M5 13l4 4L19 7"
                                            />
                                        </svg>
                                        <span>Short selling available</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <svg
                                            className="w-4 h-4 text-blue-500"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M5 13l4 4L19 7"
                                            />
                                        </svg>
                                        <span>T+0 settlement</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <svg
                                            className="w-4 h-4 text-blue-500"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M5 13l4 4L19 7"
                                            />
                                        </svg>
                                        <span>Commissions from 0.08%</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <svg
                                            className="w-4 h-4 text-blue-500"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M5 13l4 4L19 7"
                                            />
                                        </svg>
                                        <span>Dividends paid in cash</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <svg
                                            className="w-4 h-4 text-blue-500"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M5 13l4 4L19 7"
                                            />
                                        </svg>
                                        <span>Access to 1500 global shares</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className='bg-black h-fit'>
                <div className='mx-auto md:max-w-7xl overflow-hidden'>
                    <div className="bg-black text-white px-6 py-12 sm:px-12 lg:px-24">
                        <h1 className="text-center text-3xl font-bold mb-8">Industradeacad Legal Docs</h1>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                            {items.map((item, index) => (
                                <div
                                    key={index}
                                    className="flex flex-col items-start p-6 bg-gray-900 rounded-lg shadow-lg"
                                >
                                    <div
                                        className={`flex items-center justify-center ${item.iconBg} text-white h-12 w-12 rounded-full text-lg mb-4`}
                                    >
                                        {item.icon}
                                    </div>
                                    <h2 className="text-xl font-semibold mb-4">{item.title}</h2>
                                    <p className="text-gray-400 mb-4">{item.description}</p>
                                    <div>
                                        {item.links.map((link, i) => (
                                            <a
                                                key={i}
                                                href={link.href}
                                                className="text-blue-400 hover:underline block"
                                            >
                                                {link.name}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <Footer/>
            </div>
        </>
    )
}

export default About